import { useRouter } from 'next/router'
import type { ReactElement } from 'react'

import { composeUrl } from '@lib/utils/url'

import {
  ComponentLinkTargetTab,
  type TypeComponentLinkEntry,
} from '@contentful-types/component-link'

import { type CtaProps } from '@components/cta/cta-prop-types'
import { Link } from '@components/ui-core/link/link'
import { Text, type TextVariant } from '@components/ui-core/text/text'

export interface ComponentLinkProps extends Omit<CtaProps, 'onClick' | 'text' | 'as'> {
  targetLink: TypeComponentLinkEntry
  isEmbedded?: boolean
  className?: string
  textVariant?: TextVariant
}

export function ComponentLink(data: ComponentLinkProps): ReactElement {
  const { targetTab, relationToUrl, appendCurrentQueryParams, targetUrl, title } =
    data.targetLink.fields
  const { query } = useRouter()
  const href = appendCurrentQueryParams ? composeUrl(targetUrl, query) : targetUrl

  return (
    <Link
      href={href}
      target={targetTab === ComponentLinkTargetTab.Blank ? '_blank' : '_self'}
      rel={relationToUrl?.join(' ')}
      title={title}
    >
      <Text as="span" variant={data.textVariant ?? 'bodySmall'}>
        {data.targetLink.fields.embeddedEntryText}
      </Text>
    </Link>
  )
}
